var _path, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTowbar2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 9.5C31 12.5376 28.5376 15 25.5 15C22.4624 15 20 12.5376 20 9.5C20 6.46243 22.4624 4 25.5 4C28.5376 4 31 6.46243 31 9.5ZM20.6923 20.3043H16V24.5H25C26.6569 24.5 28 23.1569 28 21.5V16H23.6923V17.3044C23.6923 18.9612 22.3492 20.3043 20.6923 20.3043ZM11 17H1V27H11C13.2091 27 15 25.2091 15 23V21C15 18.7909 13.2091 17 11 17Z",
    fill: "black",
    fillOpacity: 0.88
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 22,
    r: 1,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 22,
    r: 1,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTowbar2);
export default __webpack_public_path__ + "static/media/towbar-2.a20be205eb9f5abadef49f816b15d87b.svg";
export { ForwardRef as ReactComponent };